export default "__VITE_ASSET__bYkHNLFx__"